import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { postContactus } from "../../api/api";   // 👈 IMPORT API
import "./Contact.css";

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            message: "",
            loading: false,
        };
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ loading: true });

        try {
            await postContactus({
                name: this.state.name,
                email: this.state.email,
                message: this.state.message,
            });

            alert("Message Sent Successfully 🍽️");

            this.setState({
                name: "",
                email: "",
                message: "",
                loading: false,
            });
        } catch (error) {
            console.error(error);
            alert("Something went wrong");
            this.setState({ loading: false });
        }
    };

    render() {
        return (
            <div className="container-fluid m-0 p-0">

                {/* HERO SECTION */}
                <div className="contact-us text-center m-0">
                    
                    <div className="contact-overlay">
                        <h1 className="fw-bold">Contact Us 🍽️</h1>
                        <p className="text-light">
                            We'd love to hear from you. Send us your message!
                        </p>
                    </div>
                </div>

                <div className="container py-5">
                    <div className="row">
                        <div className="col-lg-6 card shadow-sm p-4 ">
                            <h4 className="mb-4 fw-bold">Let's Cook Together 🍳</h4>

                            <p className="text-muted">
                                Tried one of our recipes? Have your own twist?
                            </p>

                            <p>
                                💬 Share your experience with us
                            </p>
                            <hr />
                            <h5 className="mt-4 fw-bold">Food Thought of the Day 🍲</h5>
                            <p className="text-muted fst-italic">
                                “Good food is all the sweeter when shared with good friends.”
                            </p>
                        </div>
                        {/* CONTACT FORM */}
                        <div className="col-lg-6 mb-4">
                            <div className="card shadow-sm p-4">
                                <form onSubmit={this.handleSubmit}>

                                    <div className="mb-3">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={this.state.name}
                                            onChange={this.handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            value={this.state.email}
                                            onChange={this.handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label>Message</label>
                                        <textarea
                                            name="message"
                                            rows="5"
                                            className="form-control"
                                            value={this.state.message}
                                            onChange={this.handleChange}
                                            required
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-warning w-100"
                                        disabled={this.state.loading}
                                    >
                                        {this.state.loading ? "Sending..." : "Send Message 🍴"}
                                    </button>

                                </form>
                            </div>
                        </div>

                        {/* CONTACT DETAILS
                        <div className="col-lg-6">
                            <div className="card shadow-sm p-4">
                                <h4 className="mb-4 fw-bold">Contact Details</h4>

                                <p>📍India</p>
                                <p>📧 flavoursnest1@gmail.com</p>
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Contact);